<cs-header>
  <cs-header-title>{{ LL.referral.hub.title() }}</cs-header-title>
</cs-header>

<cs-content>
  <!-- cs-card-list is what gives this page the standard centred column and its
       small-screen padding. Without it the content ran the full width of a
       desktop window. -->
  <cs-card-list>
    <cs-card>
      <cs-card-content>
        <div class="field-help">{{ LL.referral.hub.subtitle() }}</div>

        @switch (loadState) {
          @case (ReferralHubLoadState.Loading) {
            <div class="hub-spinner">
              <cs-spinner></cs-spinner>
            </div>
          }

          @case (ReferralHubLoadState.Failed) {
            <div class="hub-error">{{ LL.referral.hub.loadFailed() }}</div>
            <cs-button tertiary small id="referral-hub-retry-button" (click)="onRetryClick($event)"
              [label]="LL.referral.hub.retryButton()"></cs-button>
          }

          @case (ReferralHubLoadState.Ready) {
            <div class="field-label">{{ LL.referral.hub.messageLabel() }}</div>
            <cs-textarea id="referral-hub-message" [(value)]="message" [rows]="3"></cs-textarea>

            <div class="field-label">{{ LL.referral.hub.linkLabel() }}</div>
            <!-- tap to copy, the same shape the coach invite link uses -->
            <div class="link-box" (click)="onCopyLinkClick($event)">
              <span class="link-text" id="referral-hub-link">{{ inviteLink }}</span>
              <cs-icon name="copy"></cs-icon>
            </div>

            <div class="field-label">{{ LL.referral.hub.codeLabel() }}</div>
            <div class="link-box" (click)="onCopyCodeClick($event)">
              <span class="code-text" id="referral-hub-code">{{ code }}</span>
              <cs-icon name="copy"></cs-icon>
            </div>
          }
        }
      </cs-card-content>
    </cs-card>

    @if (isCodeEntryOffered) {
      <cs-card>
        <cs-card-title>{{ LL.referral.hub.wereYouInvited.title() }}</cs-card-title>
        <cs-card-content>
          <div class="field-help">{{ LL.referral.hub.wereYouInvited.subtitle() }}</div>
          <!-- The same line the invite landing page carries (#4963 phase 3).
               Somebody who claims by typing a code here never sees that page. -->
          <div class="field-help" id="referral-hub-disclosure">{{ LL.referral.disclosure() }}</div>
          <cs-input id="referral-hub-code-input" [(value)]="enteredCode"
            [placeholder]="LL.referral.hub.wereYouInvited.placeholder()"></cs-input>
          <cs-button secondary medium id="referral-hub-apply-code-button" [disabled]="isCodeEntryBusy"
            (click)="onApplyCodeClick($event)" [label]="LL.referral.hub.wereYouInvited.submitButton()"></cs-button>
        </cs-card-content>
      </cs-card>
    }

    <!-- The friends this person has brought in (#4963 phase 3). Its own card and
         its own load state: it is a separate server call, and a list that failed
         must never stop somebody seeing and sharing their own invite above. -->
    <cs-card>
      <cs-card-title>{{ LL.referral.hub.friends.title() }}</cs-card-title>
      <cs-card-content>
        @switch (friendsLoadState) {
          @case (ReferralHubLoadState.Loading) {
            <div class="hub-spinner">
              <cs-spinner></cs-spinner>
            </div>
          }

          @case (ReferralHubLoadState.Failed) {
            <div class="hub-error">{{ LL.referral.hub.friends.loadFailed() }}</div>
            <cs-button tertiary small id="referral-hub-friends-retry-button"
              (click)="onRetryFriendsClick($event)" [label]="LL.referral.hub.retryButton()"></cs-button>
          }

          @case (ReferralHubLoadState.Ready) {
            @if (friends.length === 0) {
              <div class="field-help" id="referral-hub-friends-empty">{{ LL.referral.hub.friends.empty() }}</div>
            } @else {
              <div class="field-help" id="referral-hub-friends-count">
                {{ LL.referral.hub.friends.count({ count: friends.length }) }}
              </div>
              <!-- No trackBy key exists to give: the rows deliberately carry no
                   identifier at all, because nothing but a first name and a status
                   may cross the wire. The list is short and re-rendered only on a
                   reload, so rebuilding it costs nothing worth a field. -->
              @for (friend of friends; track $index) {
                <div class="friend-row">
                  <span class="friend-name">{{ friendName(friend) }}</span>
                  <span class="friend-status">{{ friendStatusLabel(friend) }}</span>
                </div>
              }
            }
          }
        }
      </cs-card-content>
    </cs-card>

    <!-- kept OUTSIDE the card above so the outcome of a code that was accepted
         survives the box being taken away -->
    @if (codeEntryMessage !== '') {
      <cs-card>
        <cs-card-content>
          <div class="code-result" id="referral-hub-code-result">{{ codeEntryMessage }}</div>
        </cs-card-content>
      </cs-card>
    }
  </cs-card-list>
</cs-content>

<cs-page-action-buttons>
  <cs-button medium id="referral-hub-share-button" [disabled]="loadState !== ReferralHubLoadState.Ready"
    (click)="onShareClick($event)" [label]="LL.referral.hub.shareButton()"></cs-button>
</cs-page-action-buttons>
